import { CommandVariables } from '../types/approvalTypes';
import { SelectProps } from '@amzn/awsui-components-react';

export const formatTime = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};

export const getCommandVariables = (
  selectedAPI: SelectProps.Option | null,
  selectedInstance: SelectProps.Option | null,
  domainIdentifier: string,
  mode: 'submit' | 'check' | 'return',
  options: {
    approverId?: string;
    approvalId?: string;
    requestId?: string;
  }
): CommandVariables => {
  if (!selectedInstance?.value) {
    throw new Error('No instance selected');
  }

  if (!selectedAPI?.value) {
    throw new Error('No API selected');
  }

  const baseVariables: CommandVariables = {
    url: selectedAPI.value,
    args: {
      domain_identifier: domainIdentifier,
      instance_id: selectedInstance.value,
    },
    confirm: {
      is_confirmed: true
    }
  };

  switch (mode) {
    case 'submit':
      if (!options.approverId) {
        throw new Error('Approver ID is required for submit mode');
      }
      return {
        ...baseVariables,
        approval: {
          approvers: [{
            type: 'UserApprover',
            id: options.approverId,
            user: {
              id: options.approverId,
              type: 'LdapUser'
            }
          }],
          mode: 'submit'
        }
      };

    case 'check':
    case 'return':
      if (!options.approvalId) {
        throw new Error(`Approval ID is required for ${mode} mode`);
      }
      return {
        ...baseVariables,
        approval: {
          id: options.approvalId,
          mode: mode
        }
      };
  }
};
